export const CONSENT_COOKIE_NAME = 'syrcha_consent'
export type ConsentValue = 'granted' | 'denied'

export function getConsentFromDocument(): ConsentValue | null {
	const match = document.cookie
		.split('; ')
		.find((row) => row.startsWith(`${CONSENT_COOKIE_NAME}=`))
	if (!match) return null
	const value = match.split('=')[1]
	if (value === 'granted' || value === 'denied') return value
	return null
}

export function setConsentCookie(value: ConsentValue) {
	const maxAge = 365 * 24 * 60 * 60 // 1 year
	document.cookie = `${CONSENT_COOKIE_NAME}=${value}; path=/; max-age=${maxAge}; SameSite=Lax`
}
